$shm_projects_image_viewer $mol_pop
	uri \
	content /
	opened_uri? \
	auto /
		^
		<= image_escape_listener null
	attr *
		^
		expanded <= expanded false
	Anchor <= Preview $mol_view
		event *
			click? <=> image_toggle? null
		sub <= viewer_content /
	bubble_content /
		<= Overlay $mol_view
			attr *
				^
				role \dialog
				aria-modal \true
			event *
				click? <=> image_close? null
			sub /
				<= Full $mol_image
					uri <= opened_uri
					loading \eager
					decoding \sync
	Preview_image $mol_image
		uri <= uri
		loading \eager
		decoding \sync
